import requests from './httpService';

const CityService = {
  getAllCity() {
    return requests.get('/city/list');
  },
  getCity(body) {
    return requests.post('/city/get', body);
  },
  createCity(body) {
    return requests.post('/city/add', body);
  },
  getCityById(id) {
    return requests.get(`/city/${id}`);
  },
  deleteCity(body) {
    return requests.delete(`/city/${body._id}`);
  },
  updateCity(body) {
    return requests.put(`/city/${body._id}`, body);
  },
  addAllCity(body) {
    return requests.post('/city/all', body);
  },
};

export default CityService;

